import React from "react";
import { useQuery } from "@apollo/client";
import { H3 } from "common/text";
import { Alert } from "antd";
import { useTranslation } from "react-i18next";

import { ParticipationCerts, GraduationCert } from "types";

import GET_CERTS from "graphql/queries/GetMyCertificates";
import * as Styled from "./styles";
import Certificate from "./Certificate";

const MyCertificates = () => {
  const { t } = useTranslation("my_certificates");
  const { data, loading, error } = useQuery(GET_CERTS);

  if (loading) {
    return <Alert message={t("Loading...")} type="info" />;
  }
  if (error) {
    return <Alert message={t("Cannot load, please try again.")} type="error" />;
  }

  const { participationCerts, graduationCerts } = data;

  return (
    <div>
      <Styled.Section>
        <H3>{t("PARTICIPATION CERTIFICATES")}</H3>
        {participationCerts.length === 0 && (
          <Styled.InfoText>
            {t(
              "You don't have any participation certificate yet. Please come back later."
            )}
          </Styled.InfoText>
        )}
        <div>
          {participationCerts.map((cert: ParticipationCerts) => (
            <Certificate cert={cert} />
          ))}
        </div>
      </Styled.Section>
      <Styled.Section>
        <H3>{t("GRADUATION CERTIFICATES")}</H3>
        {graduationCerts.length === 0 && (
          <Styled.InfoText>
            {t(
              "You don't have any graduation certificate yet. Please come back later."
            )}
          </Styled.InfoText>
        )}
        <div>
          {graduationCerts.map((cert: GraduationCert) => (
            <Certificate cert={cert} />
          ))}
        </div>
      </Styled.Section>
    </div>
  );
};

export default MyCertificates;
